export const defaultClasses = {
	actionbar: "mod-frontend-form__wysiwyg-actionbar",
	button: "mod-frontend-form__wysiwyg-button",
	content: "mod-frontend-form__wysiwyg-content",
	selected: "mod-frontend-form__wysiwyg-button--selected",
};
